import { render, staticRenderFns } from "./users.vue?vue&type=template&id=0d613152"
import script from "./users.vue?vue&type=script&lang=js"
export * from "./users.vue?vue&type=script&lang=js"
import style0 from "./users.vue?vue&type=style&index=0&id=0d613152&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports